// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/News/News.sass
// module id = 441
// module chunks = 0